/*
appGallery.ts
Copyright © 2026 Xerox Corporation. All Rights Reserved.

Copyright protection claimed includes all forms and matters of copyrightable material
and information now allowed by statutory or judicial law or hereinafter granted,
including without limitation, material generated from the software programs which
are displayed on the screen such as icons, screen display looks, etc.
*/

import { localVar } from "../constants/storage.const";
import { getLocalVar, setLocalVar } from "./browserStorage";
import { getUrlSearchParamsAsObj } from "./util";

export interface AppGallerySettings {
    deviceid?: string;
    apikey?: string;
    appid?: string;
}
const urlSearchParamsObj: AppGallerySettings = getUrlSearchParamsAsObj();
const calledByShell = !!urlSearchParamsObj.deviceid

const storeAppGallerySettings = (): void => {
    setLocalVar(localVar.appGallerySettings, JSON.stringify(urlSearchParamsObj));
};

const getStoredAppGallerySettings = (): AppGallerySettings => {
    const storedSettings = getLocalVar(localVar.appGallerySettings);
    return storedSettings ? JSON.parse(storedSettings) : {};
};

export const getAppGallerySettings = (): AppGallerySettings => {
    if (calledByShell)
        storeAppGallerySettings();

    return getStoredAppGallerySettings();
};